import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ArrowForward from "@mui/icons-material/ArrowForward";
import AllInclusive from "@mui/icons-material/AllInclusive";
import Brightness5 from "@mui/icons-material/Brightness5";
import People from "@mui/icons-material/People";
import Icon from "@mui/material/Icon";
import useMediaQuery from "@mui/material/useMediaQuery";
import brand from "dan-api/dummy/brand";
import logo from "dan-images/logo.svg";
import { Input } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import ValidationUtil from "../Validation/ValidationUtil";
import Services from "../../Services/Services";
import iseapmu from "../../images/iseapmu.webp";
import Swal from "sweetalert2";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { createCanvas } from "canvas";
import useStyles from "../../components/Forms/user-jss";
import { userLogin, userRedirectLogin } from "../../Services/UserUtil";

import "./UserRegistration.css";

const LinkBtn = React.forwardRef(function LinkBtn(props, ref) {
  // eslint-disable-line
  return <NavLink to={props.to} {...props} innerRef={ref} />; // eslint-disable-line
});

const UserRegistration = (props) => {
  const formRef = useRef(null);
  const { classes, cx } = useStyles();
  const [tab, setTab] = useState(0);
  const { slideMode } = props;

  const initialState = {
    fields: {},
    errors: {},
  };
  const [inputState, setInputState] = useState({
    referral: 0,
  });

  const [getUserDetails, setUserDetails] = useState(initialState);
  const [showInputField, setShowInputField] = useState(0);
  const [showMessage, setShowMessage] = useState(false);
  // const [passwordValue, setPasswordValue] = useState('')
  const [showPasswordValue, setShowPasswordValue] = useState(false);
  // const [confirmPasswordValue, setConfirmPasswordValue] = useState('')
  const [showConfirmPasswordValue, setShowConfirmPasswordValue] =
    useState(false);
  const gradient = useSelector((state) => state.ui.gradient);

  const [getURLReffCode, setCurrURLReffCode] = useState("");
  const [getCurrClientID, setCurrClientID] = useState("");
  // const [getCaptchaImg, setCaptchaImg] = useState();
  const [getCaptchaString, setCaptchaString] = useState();
  const [getCaptchaId, setCaptchaId] = useState();
  const [getCaptchaKey, setCaptchaKey] = useState();
  const [getNewCaptchaImg, setNewCaptchaImg] = useState();
  const [getErrorMsg, setErrorMsg] = useState({});
  const [getImageSrc, setImageSrc] = useState(null);
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const mdDown = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const { handleSubmit, pristine, submitting, deco } = props;

  const required = (value) => (value === null ? "Required" : undefined);
  const email = (value) =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
      ? "Invalid email"
      : undefined;

  //   const passwordsMatch = (value, allValues) => {
  //     if (value !== allValues.password) {
  //       return "Passwords dont match";
  //     }
  //     return undefined;
  //   };

  const passwordsMatch = (value, getUserDetails) => {
    if (value !== getUserDetails.field.password) {
      // console.log("match");
      return "Passwords dont match";
    }
    return undefined;
  };

  const togglePasswordVisibility = () => {
    setShowPasswordValue(!showPasswordValue);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPasswordValue(!showConfirmPasswordValue);
  };

  // const handleChangeTab = (event, value) => {
  //   setTab(value);
  // };

  useEffect(() => {
    // const currURLReffCode = window.location.href.split("=")[1];
    // // console.log("ref Code from url", currURLReffCode);
    // setCurrURLReffCode(currURLReffCode);
    const url = new URL(window.location.href);
    const currURLReffCode = url.searchParams.get("referral_code");
    setCurrURLReffCode(currURLReffCode);
    const clientId = url.searchParams.get("client_id");
    setCurrClientID(clientId);
  }, []);

  const loginSubmit = () => {
    // userLogin();
    const bodyjson = {
      client: getCurrClientID || "ivp",
    };
    // userLogin();
    userRedirectLogin(bodyjson.client);
  };

  const handleChange = (e) => {
    let fields = getUserDetails.fields;
    fields[e.target.name] = e.target.value;
    setUserDetails({ ...getUserDetails, fields });
  };

  const handleChangeRefCode = (name) => (event) => {
    setInputState({
      ...inputState,
      [name]: event.target.checked ? 1 : 0,
    });
    setShowInputField(event.target.checked ? 1 : 0);
  };

  useEffect(() => {
    if (getURLReffCode) {
      let fields = getUserDetails.fields;
      fields["referral_code"] = getURLReffCode;
      setUserDetails({ ...getUserDetails, fields });
      setInputState({
        ...inputState,
        referral: 1,
      });
      setShowInputField(1);
    }
  }, [getURLReffCode]);

  const { referral } = inputState;

  const [dataState, setDataState] = useState({
    showPassword: false,
  });

  const firstNameChange = () => {
    let fields = getUserDetails.fields;
    let errors = getUserDetails.errors;
    if (!ValidationUtil.isCharacter(fields["first_name"])) {
      errors["first_name"] = "*Only alphabatic characters are allowed ";
    } else {
      delete errors["first_name"];
    }

    setUserDetails({ ...getUserDetails, errors });
  };

  const lastNameChange = () => {
    let fields = getUserDetails.fields;
    let errors = getUserDetails.errors;
    if (!ValidationUtil.isCharacter(fields["last_name"])) {
      errors["last_name"] = "*Only alphabatic characters are allowed ";
    } else {
      delete errors["last_name"];
    }

    setUserDetails({ ...getUserDetails, errors });
  };

  const onMobileChange = () => {
    let fields = getUserDetails.fields;
    let errors = getUserDetails.errors;
    if (
      !ValidationUtil.validContactNumberNoZero(fields["mobileno"]) ||
      !ValidationUtil.numberTest(fields["mobileno"])
    ) {
      errors["mobileno"] = "*Enter Valid Mobile Number ";
    } else if (!ValidationUtil.isContactNumber(fields["mobileno"])) {
      errors["mobileno"] = "*Only numbers are allowed ";
    } else {
      delete errors["mobileno"];
    }

    setUserDetails({ ...getUserDetails, errors });
  };

  const onEmailChange = () => {
    let fields = getUserDetails.fields;
    let errors = getUserDetails.errors;
    if (!ValidationUtil.isEmail(fields["email"])) {
      errors["email"] = "*Only Valid Email ID are Allowed ";
    } else {
      delete errors["email"];
    }

    setUserDetails({ ...getUserDetails, errors });
  };
  const handleToggleInstruction = () => {
    setShowMessage(!showMessage);
  };
  const onPasswordChange = () => {
    let fields = getUserDetails.fields;
    let errors = getUserDetails.errors;
    if (!ValidationUtil.isRequired(fields["password"])) {
      errors["password"] = "*Password can't be empty";
    } else if (!ValidationUtil.isStrongPassword(fields["password"])) {
      errors["password"] =
        "*Password must contain (uppercase, lowercase, digits, special characters)";
    } else if (!ValidationUtil.passwordCharacters(fields["password"])) {
      errors["password"] = "*Password must be at least 8 characters";
    } else {
      delete errors["password"];
    }

    setUserDetails({ ...getUserDetails, errors });
  };

  const onConfirmPassword = () => {
    let fields = getUserDetails.fields;
    let errors = getUserDetails.errors;
    if (fields["password"] != fields["confirm_password"]) {
      errors["confirm_password"] = "*Password do not match";
    } else if (fields["password"] === fields["confirm_password"]) {
      delete errors["confirm_password"];
    } else {
      delete errors["confirm_password"];
    }
  };

  const validate = () => {
    let fields = getUserDetails.fields;
    let errors = {};
    let formIsValid = true;

    if (
      !ValidationUtil.validContactNumberNoZero(fields["mobileno"]) ||
      !ValidationUtil.isContactNumber(fields["mobileno"])
    ) {
      formIsValid = false;
      errors["mobileno"] = "*Please enter mobile number";
    } else if (fields["password"] != fields["confirm_password"]) {
      formIsValid = false;
      errors["confirm_password"] = "*Password do not match";
    } else if (!ValidationUtil.isCharacter(fields["first_name"])) {
      formIsValid = false;
      errors["first_name"] = "*Only alphabatic characters are allowed ";
    } else if (!ValidationUtil.isCharacter(fields["last_name"])) {
      formIsValid = false;
      errors["last_name"] = "*Only alphabatic characters are allowed ";
    }
    // else if (ValidationUtil.isStrongPassword(fields["password"])) {
    //   formIsValid = false;
    //   errors["password"] = "*Make a strong password";
    // }
    setUserDetails({ ...getUserDetails, errors });

    return formIsValid;
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClickShowPassword = () => {
    const { showPassword } = getUserDetails.fields.password;
    setDataState({
      ...getUserDetails,
      showPassword: !showPassword,
    });
  };

  useEffect(() => {
    refreshCaptcha();
  }, []);

  const refreshCaptcha = (e) => {
    // e.preventDefault();
    // const getCaptchaRefresh = async () => {
    //   try {
    //     const res = await Services.getCaptcha();
    //     // console.log("captcha", res);
    //     if (res.status === 200) {
    //       // const captchaValue = res.data.data.captcha_image;
    //       const captchaValue = res.data.data.captcha_str;
    //       const captchaId = res.data.data.c_id;
    //       const captchaKey = res.data.data.key;
    //       // console.log("captha str", captchaKey);
    //       // const captchaImageUrl = `http://${captchaValue}?t=${Date.now()}`;
    //       // const captchaImageUrl = `http://${captchaValue}?t=${new Date().getTime()}`;
    //       // setCaptchaImg(captchaImageUrl);
    //       // const captchaStr = `${captchaValue} ${new Date().getTime()}`;
    //       const captchaStr = `${captchaValue} `;
    //       setCaptchaString(captchaStr);
    //       setCaptchaId(captchaId);
    //       setCaptchaKey(captchaKey);
    //     } else {
    //       Swal.fire({
    //         title: "Error",
    //         text: "captcha err",
    //         icon: "error",
    //       }).then(() => {
    //         refreshCaptcha();
    //       });
    //     }
    //   } catch (err) {
    //     // console.log("captcha err", err);
    //     const errorMsg = err.response?.data;
    //     setErrorMsg(errorMsg);
    //     let errorMessage = "";
    //     if (errorMsg) {
    //       Object.keys(errorMsg).forEach(([field, value]) => {
    //         errorMessage += errorMsg[field] + "\n";
    //       });

    //       if (err.response.status === 400) {
    //         Swal.fire({
    //           title: "Error",
    //           text: errorMessage,
    //           icon: "error",
    //         }).then(() => {
    //           refreshCaptcha();
    //         });
    //       } else {
    //         Swal.fire({
    //           title: "Error",
    //           text: errorMessage,
    //           icon: "error",
    //         }).then(() => {
    //           refreshCaptcha();
    //         });
    //       }
    //     }
    //   }
    // };
    const getCaptchaRefresh = async () => {
      try {
        const response = await Services.getCaptchaForOtpLoginRegistration();
        if (response.status === 200) {
          // console.log("captcha response", response);
          const captchaString = response.data?.captcha_image;
          setCaptchaString(captchaString);
          const mimeType = "image/png"; // Set the correct MIME type for the image
          const byteCharacters = atob(captchaString);
          const byteArrays = [];
          for (let i = 0; i < byteCharacters.length; i++) {
            byteArrays.push(byteCharacters.charCodeAt(i));
          }
          const blob = new Blob([new Uint8Array(byteArrays)], {
            type: mimeType,
          });

          const imageUrl = URL.createObjectURL(blob);
          setImageSrc(imageUrl);
        }
      } catch (err) {
        // console.log("captcha err", err.response);
        const errorMsg = err.response?.data.detail;
        setErrorMsg(errorMsg);
        let errorMessage = "";
        if (errorMsg) {
          Object.keys(errorMsg).forEach(([field, value]) => {
            errorMessage += errorMsg[field] + "\n";
          });

          if (err.response.status === 400) {
            Swal.fire({
              title: "Error",
              text: errorMsg || errorMessage,
              icon: "error",
            }).then(() => {
              // refreshCaptcha();
              getCaptchaRefresh();
            });
          } else {
            Swal.fire({
              title: "Warning",
              text: errorMsg || errorMessage,
              icon: "warning",
            }).then(() => {
              // refreshCaptcha();
              getCaptchaRefresh();
            });
          }
        }
      }
    };
    getCaptchaRefresh();
    formRef.current.reset();
  };

  const canvas = createCanvas(120, 50);
  const context = canvas.getContext("2d");

  context.fillStyle = "#f0f0f0";

  context.fillRect(0, 0, canvas.width, canvas.height);
  // Draw captcha text
  // context.font = "23px Arial";
  context.font = "bold  25px Comic Sans MS";
  context.fillStyle = "#000";
  context.textBaseline = "middle";
  context.fillText(getCaptchaString, 10, canvas.height / 2);

  const captchaDataURL = canvas.toDataURL("image/png");

  const getUserRegFormData = () => {
    const {
      email,
      first_name,
      last_name,
      password,
      mobileno,
      confirm_password,
      key,
      captcha,
      referral_code,
    } = getUserDetails.fields;

    let extractedData;
    if (referral_code) {
      extractedData = {
        email: email?.toLowerCase(),
        first_name,
        last_name,
        password,
        mobileno,
        confirm_password,
        key: getCaptchaKey,
        captcha,
        referral_code,
        referral: "1",
        // mode: "ivp",
        mode: getCurrClientID || "ivp",
      };
    } else {
      extractedData = {
        email: email?.toLowerCase(),
        first_name,
        last_name,
        password,
        mobileno,
        confirm_password,
        key: getCaptchaKey,
        captcha,
        referral_code: "",
        referral: "0",
        // mode: "ivp",
        mode: getCurrClientID || "ivp",
      };
    }

    return extractedData;
  };

  const formSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const {
        email,
        first_name,
        last_name,
        password,
        mobileno,
        confirm_password,
        key: getCaptchaKey,
        captcha,
        referral_code,
        referral,
      } = getUserDetails.fields;
      const bodyjson = {
        email,
        first_name,
        last_name,
        mobileno,
        mode: "ivp",
        password,
        confirm_password,
        key: getCaptchaKey,
        captcha,
        referral_code: "",
        referral,
      };

      const userRegData = getUserRegFormData();

      Services.userRegistration(userRegData)
        .then(async (response) => {
          // console.log("rsgistartion res", response);
          if (response.status === 200) {
            //   showSuccessAlert();
            Swal.fire({
              title: "Success!",
              text: response.data.message || response.data.errors,
              icon: "success",
            }).then(function () {
              loginSubmit();
              formRef.current.reset();
            });
          } else {
            await Swal.fire({
              title: "Error",
              text: response.data.errors,
              icon: "error",
            }).then(() => {
              refreshCaptcha();
            });
          }
        })
        .catch((err) => {
          const errorMsg = err.response?.data;
          setErrorMsg(errorMsg);
          // console.log("reg err", err.response);
          const resError = err.response.data.errors;
          let errorMessage = "";
          Object.keys(errorMsg).forEach(([field, value]) => {
            errorMessage += errorMsg[field] + "\n";
          });

          if (
            err.response.status === 400
            // err.response.status === 500 ||
            // err.response.status === 401
          ) {
            Swal.fire({
              title: "Error",
              text: errorMessage || resError,
              icon: "error",
            }).then(() => {
              refreshCaptcha();
            });
          } else {
            Swal.fire({
              title: "Error",
              text: resError || err,
              icon: "error",
            }).then(() => {
              refreshCaptcha();
            });
          }
        });
      formRef.current.reset();
    }
  };

  return (
    <Fragment>
      {/* <div className="custom-shape-divider-bottom-1701770073">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
            className="shape-fill"
          ></path>
        </svg>
      </div> */}
      <div
        className="registerMainForm"
        // className={cx(
        //   classes.banner,
        //   gradient ? classes.gradient : classes.solid,
        //   slideMode ? classes.out : classes.fit
        // )}
      >
        <div className="registerForm m-0">
          {/* {!mdUp && (
            <NavLink
              to="/"
              className={`${cx(classes.brand, classes.outer)} text-dark`}
            >
              <img src={iseapmu} alt="Isea Virtual Platform" />
              
              ISEA Virtual Platform
            </NavLink>
          )} */}
          <div className={classes.borderPaperblock}>
            {/* <Paper
              className={` p-0 ${cx(classes.paperWrap, deco && classes.petal)}`}
            > */}
            {/* {!mdDown && (
                <div className={classes.topBar}>
                  <NavLink to="/" className={classes.brand}>
                    <img src={iseapmu} alt="Isea Virtual Platform" />
                    
                    ISEA Virtual Platform
                  </NavLink>
                  <Button
                    size="small"
                    className={classes.buttonLink}
                    //   component={LinkBtn}
                    //   to="/login"
                    onClick={loginSubmit}
                  >
                    <Icon className={classes.icon}>arrow_forward</Icon>
                    Already have account ?
                  </Button>
                </div>
              )}
              <Typography variant="h4" className={classes.title} gutterBottom>
                Register
              </Typography> */}

            {tab === 0 && (
              <section className={` formSection ${classes.formWrap} p-0`}>
                <form ref={formRef} onSubmit={formSubmit}>
                  <div>
                    <div>
                      <FormControl
                        variant="standard"
                        className={`${classes.formControl} `}
                      >
                        {/* <label >Username</label> */}
                        <InputLabel
                          htmlFor="firstName"
                          className="required-label"
                        >
                          First name
                        </InputLabel>
                        <Input
                          name="first_name"
                          id="firstName"
                          placeholder="First Name"
                          required
                          value={getUserDetails.fields.first_name}
                          onChange={handleChange}
                          autoComplete="off"
                          className={`  ${classes.field} ${
                            getUserDetails.errors.first_name === undefined
                              ? ""
                              : "wrongValue"
                          } `}
                          pattern={"[a-zA-Zs , _\"''-]*"}
                          onBlur={firstNameChange}
                        />
                        <span className="errorMsg text-left text-danger">
                          {getUserDetails.errors["first_name"]}
                        </span>
                      </FormControl>
                    </div>
                    <div>
                      <FormControl
                        variant="standard"
                        className={classes.formControl}
                      >
                        {/* <label >Username</label> */}
                        <InputLabel
                          htmlFor="lastName"
                          className="required-label"
                        >
                          Last name
                        </InputLabel>
                        <Input
                          name="last_name"
                          label="Last name"
                          id="lastName"
                          placeholder="Last Name"
                          required
                          autoComplete="off"
                          value={getUserDetails.fields.last_name}
                          onChange={handleChange}
                          className={`${classes.field}   ${
                            getUserDetails.errors.last_name === undefined
                              ? ""
                              : "wrongValue"
                          } `}
                          onBlur={lastNameChange}
                          pattern={"[a-zA-Zs , _\"''-]*"}
                        />
                        <span className="errorMsg text-left text-danger">
                          {getUserDetails.errors["last_name"]}
                        </span>
                      </FormControl>
                    </div>
                    <div>
                      <FormControl
                        variant="standard"
                        className={classes.formControl}
                      >
                        {/* <label >Username</label> */}
                        <InputLabel
                          htmlFor="mobileNumber"
                          className="required-label"
                        >
                          Mobile Number
                        </InputLabel>
                        <Input
                          name="mobileno"
                          id="mobileNumber"
                          label="Mobile_Number"
                          placeholder="Mobile Number"
                          required
                          autoComplete="off"
                          value={getUserDetails.fields.mobileno}
                          onChange={handleChange}
                          onBlur={onMobileChange}
                          className={`${classes.field} ${
                            getUserDetails.errors.mobileno === undefined
                              ? ""
                              : "wrongValue"
                          }`}
                        />
                        <span className="errorMsg text-left text-danger">
                          {getUserDetails.errors["mobileno"]}
                        </span>
                      </FormControl>
                    </div>
                    <div>
                      <FormControl
                        variant="standard"
                        className={classes.formControl}
                      >
                        {/* <label >Username</label> */}
                        <InputLabel htmlFor="email" className="required-label">
                          Email
                        </InputLabel>
                        <Input
                          name="email"
                          label="Email"
                          type="email"
                          id="email"
                          placeholder="Email"
                          required
                          autoComplete="off"
                          validate={[required, email]}
                          value={getUserDetails.fields.email}
                          onChange={handleChange}
                          // onBlur={onEmailChange}
                          onBlur={() => {
                            onEmailChange();
                          }}
                          className={`${classes.field} ${
                            getUserDetails.errors.email === undefined
                              ? ""
                              : "wrongValue"
                          } `}
                        />
                        <span className="errorMsg text-left text-danger">
                          {getUserDetails.errors["email"]}
                        </span>
                      </FormControl>
                    </div>
                    <div className="passwordDiv">
                      <FormControl
                        variant="standard"
                        className={classes.formControl}
                      >
                        <InputLabel
                          htmlFor="password"
                          className="required-label"
                        >
                          Password
                        </InputLabel>
                        <Input
                          name="password"
                          label="password"
                          id="password"
                          placeholder="Password"
                          required
                          validate={[required, passwordsMatch]}
                          // type="password"
                          type={showPasswordValue ? "text" : "password"}
                          value={getUserDetails.fields.password}
                          onChange={handleChange}
                          // onBlur={onPasswordChange}
                          onBlur={() => {
                            onPasswordChange();
                            handleToggleInstruction();
                          }}
                          onFocus={handleToggleInstruction}
                          className={`${classes.field} ${
                            getUserDetails.errors.password === undefined
                              ? ""
                              : "wrongValue"
                          }`}
                        />
                        <span
                          className="eyeBtn"
                          onClick={togglePasswordVisibility}
                        >
                          {showPasswordValue ? (
                            <i className="ion-md-eye"></i>
                          ) : (
                            <i className="ion-md-eye-off"></i>
                          )}
                        </span>
                        <span className="errorMsg text-left text-danger">
                          {getUserDetails.errors["password"]}
                        </span>
                        {showMessage && (
                          <div
                            className={` mt-2 ${classes.emailInstruction}`}
                            role="alert"
                          >
                            <ul className={classes.emailInstructionUl}>
                              <span>
                                <HighlightOffIcon />
                              </span>
                              <li>Password should be minimum 8 characters</li>
                              <li>
                                Password should contain alteast one lower case
                              </li>
                              <li>
                                Password should contain alteast one upper case
                              </li>
                              <li>
                                Password should contain alteast one number
                              </li>
                              <li>
                                Password should contain atleast one of these
                                special characters(!@#$%^&*)"
                              </li>
                            </ul>
                          </div>
                        )}
                      </FormControl>
                    </div>
                    <div className="passwordDiv">
                      <FormControl
                        variant="standard"
                        className={classes.formControl}
                      >
                        <InputLabel
                          htmlFor="confirm_password"
                          className="required-label"
                        >
                          Confirm Password
                        </InputLabel>
                        <Input
                          name="confirm_password"
                          label="confirm_Password"
                          id="confirm_password"
                          placeholder="Confirm Password"
                          required
                          // type="password"
                          type={showConfirmPasswordValue ? "text" : "password"}
                          validate={[required, passwordsMatch]}
                          value={getUserDetails.fields.confirm_password}
                          onChange={handleChange}
                          onBlur={onConfirmPassword}
                          className={`${classes.field} ${
                            getUserDetails.errors.confirm_password === undefined
                              ? ""
                              : "wrongValue"
                          }`}
                        />
                        <span
                          className="eyeBtn"
                          onClick={toggleConfirmPasswordVisibility}
                        >
                          {showConfirmPasswordValue ? (
                            <i className="ion-md-eye"></i>
                          ) : (
                            <i className="ion-md-eye-off"></i>
                          )}
                        </span>
                        <span className="errorMsg text-left text-danger">
                          {getUserDetails.errors["confirm_password"]}
                        </span>
                      </FormControl>
                    </div>
                    <div>
                      <div className={`${classes.refcodeStyle} p-0`}>
                        <span>Do you have a referral code : </span>
                        <Checkbox
                          checked={referral === 1}
                          onChange={handleChangeRefCode("referral")}
                          value={inputState.referral}
                        />
                      </div>

                      {referral === 1 && showInputField === 1 && (
                        <div>
                          <FormControl
                            variant="standard"
                            className={`  ${classes.formControl}`}
                          >
                            <InputLabel htmlFor="referral_code">
                              Referral Code
                            </InputLabel>
                            <Input
                              name="referral_code"
                              id="referral_code"
                              placeholder="Enter Referral Code"
                              type="text"
                              value={getUserDetails.fields.referral_code}
                              onChange={handleChange}
                              className={`${classes.field} ${
                                getUserDetails.errors.referral_code ===
                                undefined
                                  ? ""
                                  : "wrongValue"
                              }`}
                            />
                            <span className="errorMsg text-left text-danger">
                              {getUserDetails.errors["referral_code"]}
                            </span>
                          </FormControl>
                        </div>
                      )}
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                      <div className="w-100">
                        <FormControl
                          variant="standard"
                          className={classes.formControl}
                        >
                          <InputLabel
                            htmlFor="captcha"
                            className="required-label"
                          >
                            Captcha Value
                          </InputLabel>
                          <Input
                            name="captcha"
                            id="captcha"
                            placeholder="Enter Captcha Value"
                            required
                            type="text"
                            value={getUserDetails.fields.captcha}
                            onChange={handleChange}
                            // onBlur={onConfirmPassword}
                            className={`${classes.field} ${
                              getUserDetails.errors.captcha === undefined
                                ? ""
                                : "wrongValue"
                            }`}
                          />
                          <span className="errorMsg text-left text-danger">
                            {getUserDetails.errors["captcha"]}
                          </span>
                        </FormControl>
                      </div>
                      <div className="mx-2 w-100">
                        {/* {captchaDataURL && (
                          <img src={captchaDataURL} alt={getCaptchaString} />
                        )} */}
                        {/* {getCaptchaString && <div> {getCaptchaString} </div>} */}
                        {getImageSrc && <img src={getImageSrc} alt="Captcha" />}
                      </div>
                      <div className={` mx-2 ${classes.captcha}`}>
                        <button type="button" onClick={refreshCaptcha}>
                          <i className="ion-ios-refresh"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={classes.btnArea}>
                    <Button
                      className="px-4"
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      submit
                    </Button>
                  </div>
                </form>
              </section>
            )}
            {/* </Paper> */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UserRegistration;
